import { Children } from 'react';
import PropTypes from 'prop-types';
import TabList from './TabList/TabList';
import TabListItem from './TabListItem/TabListItem';

import styles from './Tabs.module.scss';

const Tabs = ({ children, activeTab, setActiveTab, ...props }) => {
    const childrenArray = Children.toArray(children);
    const tabs = childrenArray.map(child => {
        const label = child?.props?.label;
        return label && <TabListItem
            key={label}
            data-testid={'tab_' + label}
            aria-label={'tab_' + label}
            selected={label === activeTab}
            onClick={() => setActiveTab(label)}
        >
            {child?.props?.label}
        </TabListItem>;
    });

    const pane = childrenArray.map(child => {
        const label = child?.props?.label;
        return label === activeTab && child;
    });

    return (
        <div { ...props } className={styles.tabs} data-module="govuk-tabs">
            <TabList>
                { tabs }
            </TabList>
            { pane }
        </div>
    );
};

Tabs.propTypes = {
    activeTab: PropTypes.string,
    setActiveTab: PropTypes.func.isRequired,
    children: PropTypes.any
};

Tabs.defaultProps = {
    activeTab: ''
};

export default Tabs;
